﻿window.cBuilderEmailWidgetCtrlTextBoxPrenomCon = function cBuilderEmailWidgetCtrlTextBoxPrenomCon(option) {
    var Me = this;

    window.cBuilderEmailWidgetCtrlTextBox.call(this, option);

    this.nomWidget = "dxwidgetformtextboxprenomcon"
    this.typChamp = "prenom_con";
    this.nomBt = "Prénom contact";
    this.titleBt = "Prénom d'un contact<br/>Ce champ pourra être relié à votre base de données"
    this.labelCtrl = "Prénom contact"

};